import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@/assets/css/main.styl'

Vue.use(Vuetify, {
  theme: {
    primary: '#0053E2',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#0053E2',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  iconfont: 'md'
})
